<template>
    <div>
        <feather-icon icon="CheckIcon" class="text-success icon-btn"
                      svgClasses="h-5 w-5" v-if="params.data.checkinTime"/>
        <feather-icon icon="XIcon" class="text-danger icon-btn"
                      svgClasses="h-5 w-5" v-else/>
    </div>
</template>

<script>
export default {
    name: 'CellRendererStatus',
    computed: {
        chipColor() {
            return value => {
                if (value.data.checkinTime ) {
                    return "success"
                } else if (!value.data.checkinTime) {
                    return "danger"
                }
            }
        },
        attendanceTypeString() {
            return value => {
                if (value.data.status === true) {
                    return this.$t('attendance.checkin')
                } else if (value.data.status == false) {
                    return this.$t('attendance.notCheckin')
                }
            }
        }
    }
}
</script>

<style lang="scss" scpoped>
.ag-grid-cell-chip {
    &.vs-chip-success {
        background: rgba(var(--vs-success), .15);
        color: rgba(var(--vs-success), 1) !important;
        font-weight: 500;
    }

    &.vs-chip-danger {
        background: rgba(var(--vs-danger), .15);
        color: rgba(var(--vs-danger), 1) !important;
        font-weight: 500;
    }
}
</style>
